module.exports = __webpack_public_path__ + "img/1413099318.5c9ebb08.jpg";